<template>
    <div v-if="dictionaryLoaded" class="formgrid grid">
        <div class="col-12">
            <div class="field">
                <label :for="getInputFieldName('WhatICan')">{{ useYoungLabel ?
                    dictionary.ArtistProfileFormWhatICanYoungLabel : dictionary.ArtistProfileFormWhatICanLabel }}</label>
                <Textarea :name="getInputFieldName('WhatICan')" v-model="model.WhatICan"></Textarea>
            </div>
            <div v-if="actionType == vueHelpers.createModeKey" class="field">
                <fieldset>
                    <legend>{{ dictionary.ArtistProfileFormProjectImagesFieldsetHeadline }}</legend>
                    <label>{{ dictionary.ArtistProfileFormProjectImagesLabel
                    }}</label>
                    <ProjectImagesUpload :getInputFieldNameMethod="getInputFieldName" fieldName="ProjectImages" />
                    <small>{{ dictionary.ArtistProfileFormProjectImagesHelpText }}</small>
                </fieldset>

            </div>
        </div>
        <div class="col-12 md:col-6">
            <div class="field">
                <label :for="getInputFieldName('FacebookUrl')">{{ dictionary.ArtistProfileFormFacebookLabel }}</label>
                <InputText :name="getInputFieldName('FacebookUrl')"
                    :placeholder="dictionary.ArtistProfileFormFacebookPlaceholder" type="url" v-model="model.FacebookUrl" />
            </div>
            <div class="field">
                <label :for="getInputFieldName('InstagramUrl')">{{ dictionary.ArtistProfileFormInstagramLabel }}</label>
                <InputText :name="getInputFieldName('InstagramUrl')"
                    :placeholder="dictionary.ArtistProfileFormInstagramPlaceholder" type="url"
                    v-model="model.InstagramUrl" />

            </div>
        </div>
        <div class="col-12 md:col-6">
            <div class="field">
                <label :for="getInputFieldName('TwitterUrl')">{{ dictionary.ArtistProfileFormTwitterLabel }}</label>
                <InputText :name="getInputFieldName('TwitterUrl')"
                    :placeholder="dictionary.ArtistProfileFormTwitterPlaceholder" type="url" v-model="model.TwitterUrl" />
            </div>
            <div class="field">
                <label :for="getInputFieldName('LinkedInUrl')">{{ dictionary.ArtistProfileFormLinkedInLabel }}</label>
                <InputText :name="getInputFieldName('LinkedInUrl')"
                    :placeholder="dictionary.ArtistProfileFormLinkedInPlaceholder" type="url" v-model="model.LinkedInUrl" />
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import Password from 'primevue/password';
import Checkbox from 'primevue/checkbox';
import FileUpload from './fileUpload.vue';
import ProjectImagesUpload from './projectImagesUpload.vue';
import VueHelpers from './../vueHelpers.js';

export default {
    name: "artistProfileArtistForm",
    props: ['profileModel', 'actionType', 'inputKey', 'useYoungLabel'],
    components: {
        Button,
        InputText,
        Textarea,
        Toast,
        Checkbox,
        Password,
        FileUpload,
        ProjectImagesUpload
    },
    data() {
        return {
            vueHelpers: null,
            dictionary: [],
            dictionaryLoaded: false,
            // projectImages: [], //Contains an entry for each image, not the image itself. Used to modify the input field name.
            model: {
                WhatICan: null,
                FacebookUrl: null,
                InstagramUrl: null,
                TwitterUrl: null,
                LinkedInUrl: null,
            }
        };
    },
    created() {
        const vm = this;
        vm.vueHelpers = VueHelpers;
        if (vm.profileModel) {
            vm.model = vm.profileModel;
        }

        fetch('/umbraco/api/resourcesApi/GetArtistProfileFormDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                vm.dictionaryLoaded = true;
            })
            .catch((error) => {
                console.log(error);
                vm.dictionaryLoaded = true;
            });
    },
    watch: {
        createStatus(newVal,oldVal){
            if(newVal != oldVal){
                this.$emit('createStatusUpdated',newVal);
            }
        }
    },
    computed: {
        createStatus() {
            const status = this.model.WhatICan != null && this.model.WhatICan.length > 0 ? true : false;
            return {
                key: this.inputKey,
                value: status
            };
        }
    },
    methods: {
        getInputFieldName(name) {
            if (this.inputKey) {
                return this.inputKey + '.' + name.charAt(0).toUpperCase() + name.slice(1);
            }

            return name;
        },
    }
};
</script>